import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/ph_globe.png")